/* Direct Kickstarter page: outbound intent, never a confirmed follow or Lead. */
(function () {
  'use strict';
  if (window.orbicoreKickstarterBound) return;
  window.orbicoreKickstarterBound = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-oc-ks-cta]');
    if (!link) return;
    var location = link.getAttribute('data-oc-ks-cta');
    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'KickstarterOutbound', {
          destination: 'kickstarter',
          source: 'kickstarter_landing_page',
          cta_location: location
        });
      }
    } catch (_) { /* Navigation must work even when tracking is unavailable. */ }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'kickstarter_outbound_click', {
          link_url: link.href,
          source: 'kickstarter_landing_page',
          cta_location: location,
          transport_type: 'beacon'
        });
      }
    } catch (_) { /* Navigation must work even when tracking is unavailable. */ }
  });
}());
